// Hook dodania komentarza klienta do pozycji oferty - POST /sales-crm/my-offers/:id/positions/:pid/comments

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';
import type { IPostSalesCrmMyOfferCommentPayload } from 'api/endpoints/usePostSalesCrmMyOfferComment';

const postSalesCrmMyOfferPositionComment = (
  offerId: string | number,
  positionId: number,
  payload: IPostSalesCrmMyOfferCommentPayload
): Promise<ICommandResponseSuccess> =>
  axios.post(
    `/sales-crm/my-offers/${offerId}/positions/${positionId}/comments`,
    payload
  );

export const usePostSalesCrmMyOfferPositionComment = (
  offerId: string | number,
  positionId: number,
  options?: UseMutationOptions<
    ICommandResponseSuccess,
    IError,
    IPostSalesCrmMyOfferCommentPayload
  >
) =>
  useMutation(
    (payload: IPostSalesCrmMyOfferCommentPayload) =>
      postSalesCrmMyOfferPositionComment(offerId, positionId, payload),
    options
  );
